<template>
  <div class="calendar-wraper">
    <div class="calendar-box">
      <div class="date-title">
        <div
          class="date-pre"
          @click="onCalcPreMonth(dateObj.year, dateObj.month)"
        >
          <i class="iconfont icon-return"></i>
        </div>
        <div class="date-now">{{ dateObj.year }} 年 {{ dateObj.month }} 月</div>
        <div
          class="date-next"
          @click="onCalcNextMonth(dateObj.year, dateObj.month)"
        >
          <i class="iconfont icon-enter"></i>
        </div>
      </div>
      <div class="day-wraper">
        <div v-for="(item, key) in dayList" :key="key" class="day-item">
          {{ item }}
        </div>
      </div>
      <div class="date-wraper">
        <div
          v-for="(item, key) in dateObj.dateArr"
          :key="key"
          :class="[
            'date-item',
            !item.editable ? 'cannotEdit' : '',
            item.disabled ? 'disabled' : '',
            !item.now ? 'disabled' : '',
            item.selected ? 'selected' : '',
            today === item.fullDate ? 'is-today' : '',
          ]"
          @click="onClickDateItem(item, key)"
        >
          <div>{{ showFull ? item.fullDate : item.date }}</div>
          <div class="dian" v-if="item.yue"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomCalendar",
  props: {
    // 是否展示年月日
    showFull: { type: Boolean, default: false },
    list: { type: Array, default: [] },
  },
  data() {
    return {
      dayList: ["一", "二", "三", "四", "五", "六", "日"],
      dateObj: {
        year: "",
        month: "",
        dateArr: [],
      },
      timeStamp: 0,
      delay: 700,
      today: "",
      selectedDate: [],
      disabledFun: () => false,
    };
  },
  mounted() {
    this.calcToday();
    // this.calcDateData(2024, 2)
    this.calcDateData();
  },
  methods: {
    init(arr, func) {
      this.selectedDate = arr;
      this.updateSelected();
      this.disabledFun = func;
    },
    calcToday() {
      const date = new Date();
      this.today = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, 0)}-${String(date.getDate()).padStart(2, 0)}`;
      // console.log("🚀 ~ calcToday ~ this.today:", this.today);
    },
    // 清除所有选择的日期，给父级组件调用
    clearAll() {
      this.dateObj.dateArr.forEach((it) => {
        it.selected = false;
      });
    },
    // 更新这个月份的已选日期，回显已选日期
    updateSelected() {
      this.dateObj.dateArr.forEach((item) => {
        if (this.selectedDate.includes(item.fullDate)) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    },
    // 更新单个日期的选择状态
    toggleSelectedStatus(fullDate, type = true) {
      const item = this.dateObj.dateArr.find((it) => it.fullDate === fullDate);
      item.selected = type;
    },
    // 点击单个日期
    onClickDateItem(item, key) {
      if (!item.now) return;
      if (item.disabled) return;
      let dateArr = this.dateObj.dateArr;
      for (let i = 0; i < dateArr.length; i++) {
        const e = dateArr[i];
        e.selected = false;
      }
      item.selected = true;
      console.log(item.fullDate);
      this.$emit("clickDate", {
        time: item.fullDate,
        type: 2,
      });
      // if (!item.now && item.pre) {
      //   this.onCalcPreMonth(this.dateObj.year, this.dateObj.month)
      // }
      // if (!item.now && item.next) {
      //   this.onCalcNextMonth(this.dateObj.year, this.dateObj.month)
      // }
    },
    // 点击上个月箭头
    onCalcPreMonth(year, month) {
      if (Date.now() - this.timeStamp < this.delay) return;
      this.timeStamp = Date.now();
      month = month - 1;
      if (month === 0) {
        month = 12;
        year = year - 1;
      }
      this.calcDateData(year, month);
    },
    // 点击下个月箭头
    onCalcNextMonth(year, month) {
      if (Date.now() - this.timeStamp < this.delay) return;
      this.timeStamp = Date.now();
      month = month + 1;
      if (month === 13) {
        month = 1;
        year = year + 1;
      }
      this.calcDateData(year, month);
    },
    // 计算这个月的日期
    calcDateData(year, month) {
      const curDateObj = new Date();
      const curYear = year || curDateObj.getFullYear();
      const curMonth = month || curDateObj.getMonth() + 1;
      const firstDate = `${curYear}-${curMonth}-1`;
      const firstDay = new Date(firstDate).getDay();
      const monthDateNum = this.getDaysInMonth(curYear, curMonth);
      let lastMonthDateNum = this.getDaysInMonth(curYear, curMonth - 1);
      const result = [];
      // 这个月头部的上个月的几天
      for (let pre = 0; pre < firstDay - 1; pre++) {
        const curDate1 = String(lastMonthDateNum);
        let fullDate = `${curMonth === 1 ? curYear - 1 : curYear}-${String(
          curMonth === 1 ? 12 : curMonth - 1
        ).padStart(2, 0)}-${String(curDate1).padStart(2, 0)}`;
        let fullDateTimeStamp = new Date(fullDate).getTime();
        let disabled = this.disabledFun(fullDateTimeStamp);
        result.unshift({
          pre: true,
          next: false,
          now: false,
          editable: false,
          selected: false,
          date: curDate1,
          disabled,
          fullDate,
          fullDateTimeStamp,
        });
        lastMonthDateNum--;
      }
      // 这个月的日期
      for (let cur = 1; cur <= monthDateNum; cur++) {
        const curDate2 = String(cur).padStart(2, 0);
        let fullDate = `${curYear}-${String(curMonth).padStart(2, 0)}-${String(
          curDate2
        ).padStart(2, 0)}`;
        let fullDateTimeStamp = new Date(fullDate).getTime();
        let disabled = this.disabledFun(fullDateTimeStamp);
        result.push({
          pre: false,
          next: false,
          now: true,
          editable: true,
          selected: false,
          date: curDate2,
          disabled,
          fullDate,
          fullDateTimeStamp,
        });
      }
      // 这个月尾部的下个月的几天
      for (let post = monthDateNum + 1; result.length < 42; post++) {
        const curDate3 = String(post - monthDateNum).padStart(2, 0);
        let fullDate = `${curMonth === 12 ? curYear + 1 : curYear}-${String(
          curMonth === 12 ? 1 : curMonth + 1
        ).padStart(2, 0)}-${String(curDate3).padStart(2, 0)}`;
        let fullDateTimeStamp = new Date(fullDate).getTime();
        let disabled = this.disabledFun(fullDateTimeStamp);
        result.push({
          pre: false,
          next: true,
          now: false,
          editable: false,
          selected: false,
          date: curDate3,
          disabled,
          fullDate,
          fullDateTimeStamp,
        });
      }
      this.dateObj.year = curYear;
      this.dateObj.month = curMonth;
      let time =
        this.dateObj.year +
        "-" +
        (this.dateObj.month < 10
          ? "0" + this.dateObj.month
          : this.dateObj.month);
      let time1 =
        this.dateObj.year +
        "年" +
        (this.dateObj.month < 10
          ? "0" + this.dateObj.month + "月"
          : this.dateObj.month + "月");
      this.$emit("clickDate", {
        time: time,
        time1: time1,
        type: 1,
      });
      this.$get("/nozzle/web/interview_month", {
        pageNo: -1,
        month: time,
      }).then((res) => {
        if (res.data) {
          for (let i = 0; i < result.length; i++) {
            const e = result[i];
            for (let j = 0; j < res.data.length; j++) {
              const ej = res.data[j];
              ej.start_time = this.$moment(ej.start_time).format("YYYY-MM-DD");
              if (e.fullDate == ej.start_time) {
                e.yue = true;
              }
            }
          }
          this.dateObj.dateArr = result;
        }else{
          this.dateObj.dateArr = result;
        }
      });
      // if (this.dateObj.dateArr.length == 0) {
      //   this.dateObj.dateArr = result;
      // }
      this.updateSelected();
      // console.log(
      //   "🚀 ~ calcDateData ~ this.dateObj:",
      //   JSON.parse(JSON.stringify(this.dateObj))
      // );
      // console.log("🚀 ~ calcDateData ~ monthDateNum:", monthDateNum);
      // console.log("🚀 ~ calcDateData ~ firstDate:", firstDate);
      // console.log("🚀 ~ calcDateData ~ firstDay:", firstDay);
    },
    // 计算 对应的月份有多少天
    getDaysInMonth(year, month) {
      if (typeof year !== "number" || typeof month !== "number") {
        throw new Error("year and month must be Number type");
      }
      const lastDay = new Date(year, month, 0).getDate();
      return lastDay;
    },
  },
};
</script>

<style lang="less" scoped>
.calendar-wraper {
  width: 100%;
  height: 100%;
}
.calendar-box {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  // background: pink;
  .date-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 0 10px;
    font-size: 15px;
    .date-now {
      font-weight: bold;
    }
    .date-pre,
    .date-next {
      display: inline-block;
      height: 40px;
      width: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 50%;
      & i::before {
        font-weight: bold;
      }
      &:active {
        background: #e8e8e8;
      }
    }
  }
  .day-wraper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 30px;
    box-sizing: border-box;
    .day-item {
      // flex: 1;
      width: calc(100% / 7);
      line-height: 30px;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      border-top: 1px solid rgba(196, 196, 196, 0.25);
      box-sizing: border-box;
      &:nth-child(1) {
        border-left: 1px solid rgba(196, 196, 196, 0.25);
      }
      &:nth-child(7) {
        border-right: 1px solid rgba(196, 196, 196, 0.25);
      }
    }
  }
  .date-wraper {
    display: flex;
    flex-wrap: wrap;
    height: calc(100% - 70px);
    box-sizing: border-box;
    border-top: 1px solid rgba(196, 196, 196, 0.25);
    border-left: 1px solid rgba(196, 196, 196, 0.25);
    cursor: pointer;
    .date-item {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      // width: 40px;
      // height: 40px;
      // width: 14.185%;
      font-size: 12px;
      width: calc(100% / 7);
      height: calc(100% / 6);
      font-weight: bold;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(196, 196, 196, 0.25);
      border-right: 1px solid rgba(196, 196, 196, 0.25);
      // border-left: 1px solid rgba(196, 196, 196, 0.25);
      transition: all 0.3s;
      .dian {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #409eff;
      }
      &.cannotEdit {
        // font-weight: 400!important;
        background: rgba(242, 246, 252, 1);
      }
      &.disabled {
        font-weight: 400 !important;
        background: rgb(223, 223, 223);
        color: #989899;
      }
      &.selected {
        // border-color: #b3d8ff;
        color: #409eff;
        background: #ecf5ff;
      }
      &.is-today {
        color: #409eff;
      }
    }
  }
}
</style>
